import { Button, ButtonLink } from 'components/Button';

interface ExternalBookingMsgProps {
  coachExternalBookingUrl: string;
  onContactCoach: () => void;
}

const TEXTS = {
  MESSAGE: 'This coach books through an external platform',
  BUTTON: 'Leave Bounce and book coach',
} as const;

const ExternalBookingMsg = ({
  coachExternalBookingUrl,
  onContactCoach,
}: ExternalBookingMsgProps) => {
  return (
    <div className="flex flex-col rounded-xl border border-color-border-input-lightmode bg-color-bg-lightmode-primary p-6 shadow-lightmode-primary dark:border-color-border-input-darkmode dark:bg-color-bg-darkmode-primary">
      <h2 className="typography-product-heading-compact mb-3 text-color-text-brand">Book Coach</h2>
      <p className="typography-product-body  text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
        {TEXTS.MESSAGE}
      </p>

      <div className="mt-6 flex flex-col gap-4">
        <ButtonLink
          variant="brand"
          size="lg"
          href={coachExternalBookingUrl}
          className="mx-auto"
          rel="noopener noreferrer nofollow ugc"
          isExternal
        >
          {TEXTS.BUTTON}
        </ButtonLink>
        <Button onClick={onContactCoach} size="lg" variant="secondary">
          Contact Coach
        </Button>
      </div>
    </div>
  );
};

export default ExternalBookingMsg;
